<template>
    <v-main>
      <ChatHero />
      <ChatAgnostic/>
      <ChatRouting/>
      <ChatTranslation/>
      <ChatScalable/>
      <RequestDemo msg="See how Yabbr Web Chat can unify your engagement across every channel — live, intelligent, and on-brand."/>

    </v-main>
</template>
  
<script>
import ChatHero from './ChatHero.vue'
import ChatAgnostic from './ChatAgnostic.vue'
import ChatRouting from './ChatRouting.vue'
import ChatTranslation from './ChatTranslation.vue'
import ChatScalable from './ChatScalable.vue'
import RequestDemo from './RequestDemo.vue'


export default {
  name: 'ChatPage',
  components: {
    ChatHero,
    ChatAgnostic,
    ChatRouting,
    ChatTranslation,
    ChatScalable,
    RequestDemo

  },
}
</script>
